import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../pages/AuthContext';

const BlogAdminPrivateRoute = ({ children }) => {
  const { isLogged, userRole } = useContext(AuthContext);
  
  // Check if user is a system admin
  const isSystemAdmin = isLogged && userRole === 'admin';
  
  // Check if user is logged in as blog admin by looking for the blogToken in localStorage
  const isBlogAdmin = localStorage.getItem('blogToken') !== null;

  // If either system admin or blog admin, allow access
  if (isSystemAdmin || isBlogAdmin) {
    return children;
  }
  
  // If not authenticated, redirect to blog login page
  return <Navigate to="/blog/admin-login" replace />;
};

export default BlogAdminPrivateRoute; 